import { ActionType, getType } from 'typesafe-actions';

import * as currentOrder from '../../actionCreators/currentOrder';
import { actions as fetchDeliveryEstimate } from '../../actionCreators/flows/fetchDeliveryEstimate';

const initialState = false;

export default function (
  state: boolean = initialState,
  action: ActionType<typeof currentOrder | typeof fetchDeliveryEstimate>,
): boolean {
  switch (action.type) {
    case getType(currentOrder.resetOrder): {
      return initialState;
    }
    case getType(fetchDeliveryEstimate.requested): {
      return true;
    }
    case getType(fetchDeliveryEstimate.failed):
    case getType(fetchDeliveryEstimate.blocked):
    case getType(fetchDeliveryEstimate.succeeded): {
      return false;
    }
    default:
      return state;
  }
}
